import { React } from "react";
import { Typography, styled } from "@mui/material";

const StyledFooterContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "min(1100px, calc(100% - 2rem))",
  margin: "3rem auto 0",
  padding: "0 0 1.5rem",
  [theme.breakpoints.down("sm")]: {
    width: "calc(100% - 1rem)",
    marginTop: "2rem",
  },
}));

const FooterCard = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "1.5rem 1.75rem",
  borderRadius: "2rem",
  background: "rgba(255, 248, 239, 0.8)",
  boxShadow: "0 18px 40px rgba(106, 70, 48, 0.08)",
  border: "1px solid rgba(159, 104, 72, 0.14)",
  backdropFilter: "blur(10px)",
  [theme.breakpoints.down("sm")]: {
    padding: "1.25rem 1rem",
    borderRadius: "1.5rem",
  },
}));

const StyledFooterText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "1.05rem",
  lineHeight: 1.9,
  textAlign: "center",
  maxWidth: "56rem",
  [theme.breakpoints.down("md")]: {
    fontSize: "0.95rem",
  },
}));

const FooterLink = styled("a")(({ theme }) => ({
  color: theme.palette.primary.main,
  whiteSpace: "nowrap",
  fontWeight: 700,
  textDecorationColor: "rgba(154, 93, 63, 0.35)",
}));

function Footer() {
  return (
    <StyledFooterContainer>
      <FooterCard>
        <StyledFooterText>
          To purchase Sarah&apos;s art in the form of paintings, drawings,
          T-shirts, phone cases, and more, visit{" "}
          <FooterLink
            href="https://sarah-quickel.pixels.com"
            target="_blank"
            rel="noreferrer"
          >
            sarah-quickel.pixels.com
          </FooterLink>
          . All proceeds will go to a Sarah fund supporting causes that mattered
          to her.
        </StyledFooterText>
      </FooterCard>
    </StyledFooterContainer>
  );
}

export default Footer;
